module.exports = __webpack_public_path__ + "static/media/silverStar.5aa073bc.svg";